// @flow
import ErrorField from './ErrorField'

export default ErrorField
